TaTiliValintaCtrl.$inject = ['$uibModalInstance', 'KpTili'];
export default function TaTiliValintaCtrl($uibModalInstance, KpTili) {
    var vm = this;
    vm.naytaKaikki = false;
    KpTili.query({ embed: 'hasEntries', filter: 'manualEntryAllowed' }).$promise.then(function (tilit) {
        vm.tilit = tilit;
    });
    vm.ok = function (tili) {
        $uibModalInstance.close(tili);
    };
    vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}
